import baseTheme, { ThemeTypography } from "@insite/mobius/globals/baseTheme";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { colorStrings, fontFamily } from "@tggstore/Utilities/variables";

export const headingCommon: TypographyPresentationProps = {
    fontFamily,
    lineHeight: 1.2,
    weight: 700,
    color: colorStrings.textMain,
    transform: "none",
    mergeCss: true,
};

export const bodyCommon: TypographyPresentationProps = {
    fontFamily,
    size: "16px",
    lineHeight: 1.6,
    weight: 400,
    transform: "none",
    mergeCss: true,
};

export const typography: ThemeTypography & { bodyBig: TypographyPresentationProps } = {
    h1: {
        ...baseTheme.typography.h1,
        ...headingCommon,
        lineHeight: 1.25,
        size: "36px",
    },
    h2: {
        ...baseTheme.typography.h2,
        ...headingCommon,
        size: "24px",
    },
    h3: {
        ...baseTheme.typography.h3,
        ...headingCommon,
        size: "19px",
    },
    h4: {
        ...baseTheme.typography.h4,
        ...headingCommon,
        size: "16px",
    },
    h5: {
        ...baseTheme.typography.h5,
        ...headingCommon,
        size: "16px",
    },
    h6: {
        ...baseTheme.typography.h6,
        ...headingCommon,
        size: "16px",
        transform: "uppercase",
    },

    headerPrimary: {
        ...baseTheme.typography.headerPrimary,
        ...headingCommon,
    },
    headerSecondary: {
        ...baseTheme.typography.headerSecondary,
        ...headingCommon,
    },
    headerTertiary: {
        ...baseTheme.typography.headerTertiary,
        ...headingCommon,
    },

    body: {
        ...baseTheme.typography.body,
        ...bodyCommon,
    },
    p: {
        ...baseTheme.typography.p,
        ...bodyCommon,
    },
    legend: {
        ...baseTheme.typography.legend,
        ...bodyCommon,
        size: "12px",
    },

    /* Verndale Custom Typography */
    bodyBig: {
        ...baseTheme.typography.body,
        ...bodyCommon,
        size: "18px",
    },
};
